import { useLocation } from "react-router-dom";

export const DEFAULT_EXAMINEE_SIGN_IN_NEXT_NAME = "next";
export const DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH =
  "/examinee/primary_interview_introduction";

/**
 * クエリパラメータからnextのパスを取得します。
 * next パラメータが存在しない場合、{@link DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH デフォルトのパス}を返却します。
 * @param defaultPath デフォルトのパス
 * @returns next のパス
 */
export function useExamineeSignInNextPath(
  defaultPath = DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH
) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const nextPath = query.get(DEFAULT_EXAMINEE_SIGN_IN_NEXT_NAME) ?? defaultPath;
  return nextPath;
}

/** ログイン後の既定遷移先（マイページ）。表示できる測定がある受診者に使う */
export const EXAMINEE_MYPAGE_PATH = "/examinee/mypage";

/**
 * ログイン成功後の遷移先を決定します。
 *
 * - `nextPath` が {@link DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH 既定のパス} と異なる（`next` が明示されている）場合は `nextPath` をそのまま返します。
 * - 既定のパスと同値（`next` 未指定、またはパスワード再設定経路で既定のパスが `next` として引き回された）場合は、
 *   マイページに表示できる測定があればマイページ、無ければ従来の既定のパスを返します。
 *
 * @param nextPath {@link useExamineeSignInNextPath} の戻り値
 * @param hasMeasurements `GET /api/mypage/measurements/` の results が 1 件以上か（API エラー時は false を渡す）
 * @returns 遷移先のパス
 */
export function resolveExamineeSignInNextPath(
  nextPath: string,
  hasMeasurements: boolean
): string {
  if (nextPath !== DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH) {
    return nextPath;
  }
  return hasMeasurements
    ? EXAMINEE_MYPAGE_PATH
    : DEFAULT_EXAMINEE_SIGN_IN_NEXT_PATH;
}
